import StartScreen from "../assets/StartScreen.jpg";
import EndScreen from "../assets/EndScreen.jpg";

export const NEW_DATA_EVENT = "NEW_DATA_EVENT";
export const developmentFlag = process.env.REACT_APP_API_ENDPOINT.includes('uat') || 
  process.env.REACT_APP_API_ENDPOINT.includes('dev');

export const COMPONENT_TYPE = {
  INPUT: "INPUT",
  OUTPUT: "OUTPUT"
};

export const SCREEN_TYPE = {
  START: "START",
  END: "END"
};

export const POPUP_TYPE = {
  SUBMIT: "SUBMIT",
  START_SESSION: "START_SESSION"
};

export const BASE_BUTTON_CLASS = 'min-w-[120px] bg-goldilocks font-normal rounded-[36px] mr-4 px-8 py-2 cursor-pointer';
export const BASE_GAME_TIME = (10*60);

export const DEFAULT_SCREEN_DATA = {
  START: {
    upperDescription: null,
    title: 'Codeberry',
    lowerDescription: `How to Start
1. Click Continue to begin coding.
2. Read the problem details on the left.
3. Choose your language from the top dropdown.
4. Write your code in the editor.
5. Click Compile to test it.
6. Click Submit once you’re done.`,
    buttonText: 'Continue',
    image: StartScreen
  },
  END: {
    upperDescription: null,
    title: 'Thank You!',
    lowerDescription: `Your code has been successfully submitted. We hope you had fun solving the challenge.`,
    buttonText: 'Continue',
    image: EndScreen
  }
}